module.exports = __webpack_public_path__ + "static/media/Picture9.4f265265.jpg";